<!-- 关于我们 -->
<template>
    <div class="about_wrapper">
        <div class="section_item about_section1 platform_section1">
            <div class="wrapper">
                <div class="block">
                    <div class="title">{{section1.title}}</div>
                    <div class="description">{{section1.description}}</div>
                </div> 
                <img :src="section1.link" alt="">
            </div>
        </div>
        <div class="section_item about_section2">
            <div class="about_wrapper">
                <div class="title_wrapper">
                    <div class="title">{{section2.name}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <div class="progress_wrapper">
                <div
                    v-for="(item, idx) in section2.data"
                    :key='idx'
                    class="progress_item">
                    <div class="year">
                        <span>{{item.year}}</span>
                    </div>
                    <div class="event_wrapper">
                        <div 
                            v-for="(item_event, idx_event) in item.data"
                            :key='idx_event'
                            class="event">
                            <div v-if='idx_event==0' class="dot"></div>
                            <div v-if='idx_event>0' class="line"></div>
                            <div class="month">{{item_event.month?`${item_event.month}月`: ''}}</div>
                            <div class="content">{{item_event.event}}</div>
                        </div>
                        <div class="event">
                            <div class="line"></div>
                            <div v-if='idx==section2.data.length-1' class="dot"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- part3 -->
        <div class="section_item about_section3">
             <div class="honor_wrapper">
                <div class="title_wrapper">
                    <div class="title">{{section3.name}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <div v-show='!isIE9' class="swiper-container honor_slide_wrapper">
                <div class="swiper-wrapper">
                    <div 
                        v-for="(item, idx) in section3.data || []"
                        :key="idx" 
                        class="honor_item_wrapper swiper-slide">
                        <div class="honor_item">
                            <div class="img"><img :src="item.link" alt=""></div>
                            <div class="desc_wrapper">
                                <div class="title">{{item.title}}</div>
                                <div class="description">{{item.description}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show='!isIE9' class="swiper-button-prev honor_prev"></div><!--左箭头-->
            <div v-show='!isIE9' class="swiper-button-next honor_next"></div><!--右箭头-->
            <el-carousel 
                v-show='isIE9'
                class="banner_slide_wrapper_ie9 slide_img"
                height="300px"
                :autoplay='false'
                type="card"
                indicator-position='none'>
                <el-carousel-item 
                    v-for="(item, idx) in section3.data || []"
                    :key="idx" 
                    class="IE9item">
                    <div class="honor_item">
                        <div class="img"><img :src="item.link" alt=""></div>
                        <div class="desc_wrapper">
                            <div class="title">{{item.title}}</div>
                            <div class="description">{{item.description}}</div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- part4 -->
        <div class="section_item about_section4">
             <div class="contact_wrapper">
                <div class="title_wrapper">
                    <div class="title">{{section4.name}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <div class="map_wrapper">
                <div class="map_menu">
                    <div 
                        v-for="(item, idx) in section4.data"
                        :key="idx" 
                        class="map_item"
                        :class="{'active': item.active}">
                        <div class="place" @click="bind_toggle_place(idx)">{{item.place}}</div>
                        <div v-show="item.active" 
                            class="address">{{item.address}}</div>
                        <div v-show="item.active" 
                            class="address">{{item.zip}}</div>
                    </div>
                </div>
                <div class="map_img">
                    <img v-for="(item, idx) in section4.data"
                        :key="idx" 
                        v-show="item.active"
                        :src="link">
                </div>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Vue from 'vue';
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/about.js';
    export default {
        name: "Index",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
            link() {
                return this.section4.data && this.section4.data[this.act_idx].link;
            },
            section1() {
                return data && data.section1;
            },
            section2() {
                return data && data.section2;
            },
            section3() {
                return data && data.section3;
            },
            section4() {
                return data && data.section4;
            },
            about_list() {
                return data && data.section2.data;
            },
            isIE9() {
                return !('placeholder' in document.createElement('input'));
            }
        },
        data() {
            return {
                act_idx: 0,
            }
        },
        mounted() {
            // 百度统计
            var caseSwiper = new Swiper('.honor_slide_wrapper', {
                pagination: {
                    el: '.honor_pagination',
                    // dynamicBullets: true,
                    // dynamicMainBullets: 1
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 3,
                spaceBetween : 40,
            })
        },
        methods: {
            // 切换地点
            bind_toggle_place(idx) {
                let ori_idx = this.act_idx;
                Vue.set(this.section4.data[ori_idx], 'active', false);
                Vue.set(this.section4.data[idx], 'active', true);
                this.act_idx = idx;
            }
        }
    }
</script>

<style scoped>
    /* 整个首页的包裹样式 */
    .about_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
        font-size: 0;
    }
    /* 第一部分的样式 */
    .about_section1 {
        background: linear-gradient(0deg, #f5f9ff 0%, #fcfdff 100%);
        background: #fcfdff\9\0;
    }
     /* 第二部分的样式 */
    .about_section2 {
        background: #f7f8fa;
        height: auto;
    }
    /* 标题包裹狂 */
    .about_section2 .about_wrapper {
        width: 1280px;
        margin: 58px auto 0 auto;
    }
    /* 时间线包裹框 */
    .about_section2 .progress_wrapper {
        width: 1280px;
        margin: 58px auto 20px auto;
        text-align: left
    }   
    /* 每个进度区域 */
    .progress_wrapper .progress_item {
        width: 100%;
        font-size: 0;
    }
    /* 年份 */
    .progress_item .year {
        margin-left: 190px;
        width: 120px;
        height: 40px;
        display: inline-block;
        vertical-align: top;
        color: #7e8085;
        line-height: 36px;
    }
    /* 首个年份高亮 */
    .progress_item:nth-child(1) .year {
        color: #ff824c;
    }
    /* 年份字体显示 */
    .progress_item .year span {
        font-family: HelveticaNeue-ThinExt;
        font-size: 36px;
        line-height: 40px;
    }
    /* 事件列表 */
    .progress_item .event_wrapper {
        display: inline-block;
        vertical-align: top;
    }
    
    .progress_item .event {
        height: 40px;
        position: relative;
        margin-bottom: 32px;
        color: #7e8085;
    }
    /* dot */
    .event .dot {
        position: absolute;
        width: 20px;
        left: 0;
        height: 20px;
        top: 50%;
        /* transform: translateY(-50%); */
        margin-top: -10px;
        border-radius: 50%;
        border: 1px solid #d2d3d6;
    }
    /* 首个dot高亮 */
    .progress_item:nth-child(1) .event .dot {
        border: 1px solid #FC754C;
    }
    /* dot中的圆点 */
    .event .dot:after {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        background: #d2d3d6;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        /* transform: translate(-50%, -50%); */
        margin-left: -4px;
        margin-top: -4px;
    }
    /* 首个dot中的圆点高亮 */
    .progress_item:nth-child(1) .event .dot:after {
        background: #FC754C;
    }
    /* 分割线 */
    .event .line {
        position: absolute;
        left: 0;
        top: 50%;
        /* transform: translateY(-50%); */
        width: 20px;
        height: 82px;
        margin-top: -41px;
    }

    .event .line:after {
        content: '';
        position: absolute;
        width: 1px;
        height: 100%;
        left: 50%;
        top: 50%;
        background: #d2d3d6;
        /* transform: translate(-50%, -50%); */
        margin-left: -0.5px;
        margin-top: -41px;
    }
    /* 首个event的分割线 */
    .progress_item:nth-child(1) .event .line:after {
        background: #FC754C;
    }
    /* 最后一个分割线的dot */
    .progress_item:last-child .event:last-child .dot {
        top: 100%;
        /* transform: translateY(8px); */
        margin-top: 10px;
        border: none;
    }
    /* 首个event的文字样式 */
    .progress_item:nth-child(1) .event {
        color: #292c33;
    }
    /* 月份和时间描述 */
    .month, .content {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }
    /* 月份 */
    .event .month {
        width: 50px;
        margin-left: 52px;
    }   
    /* 第三部分的样式 */
    .about_section3 {
        background: #FAFCFF;
        height: auto;
        position: relative;
    }
    /* 标题包裹狂 */
    .about_section3 .honor_wrapper {
        margin-top: 48px;
    }
    /* 轮播图包裹狂 */
    .about_section3 .honor_slide_wrapper {
        width: 1100px;
        margin: 0 auto;
        margin-top: 32px;
        margin-bottom: 50px;
    } 
    .banner_slide_wrapper_ie9 {
        margin: 0 auto;
        margin-top: 32px;
        margin-bottom: 50px;
    }
    /* 轮播图 */
    .honor_item {
        margin: 10px auto;
        width: 320px;
        height: 280px;
        background: #fff;
        border-radius: 4px;
        cursor: pointer;
        box-shadow: 0 2px 30px 0 rgba(204,230,255,0.36);
    }
    /* 图片 */
    .honor_item .img {
        height: 176px;
    }
    /* 文字区域 */
    .honor_item .desc_wrapper {
        padding: 30px 0;
    }
    /* 标题 */
    .honor_item .title {
        font-size: 18px;
        color: #292c33;
        letter-spacing: 0;
        line-height: 18px;
    }
    /* 描述 */
    .honor_item .description {
        margin-top: 10px;
        font-size: 16px;
        color: #aaadb3;
        letter-spacing: 0;
        line-height: 16px;
    }
    /* 前一张 */
    .about_section3 .honor_prev {
        left: 100px;
        margin-top: 20px;
    }
    /* 下一张 */
    .about_section3 .honor_next {
        right: 100px;
        margin-top: 20px;
    }
    /* 第四部分的样式 */
    .about_section4 {
        background: #fff;
        height: auto;
    }
    /* 标题包裹狂 */
    .about_section4 .contact_wrapper {
        width: 1280px;
        margin: 0 auto;
        margin-top: 86px;
    }
    /* 地址 */
    .about_section4 .map_wrapper {
        position: relative;
        width: 1040px;
        height: 400px;
        margin: 0 auto;
        margin-top: 32px;
        margin-bottom: 80px;
        text-align: left;
        box-shadow: 0 2px 30px 0 rgba(204,230,255,0.36);
    }
    /* 地图区域 */
    .map_wrapper .map_menu {
        width: 330px;
        padding: 24px 0;
    }
    /* 地点包裹项 */
    .map_wrapper .map_item {
        padding-left: 51px;
        height: 64px;
        line-height: 64px;
    }
    .map_item.active {
        padding-top: 24px;
        height: 160px;
        line-height: 160px;
    }
    /* 地点 */
    .map_item .place {
        font-size: 16px;
        color: #292C33;
        cursor: pointer;
    }

    .map_item.active .place{
        position: relative;
        font-size: 20px;
        color: #292C33;
        height: 24px;
        line-height: 24px;
    }

    .map_item.active .place:after {
        position: absolute;
        content: '';
        width: 3px;
        height: 24px;
        background: #FF824C;
        left: -9px;
        top: 0;
    }
    /* 地址 */
    .map_item.active .address{
        margin-top: 10px;
        font-size: 14px;
        color: #7E8085;
        line-height: 21px;
    }   
    /* 地图img */
    .map_wrapper .map_img {
        position: absolute;
        left: 330px;
        top: 0;
        width: 710px;
        height: 100%;
    }
</style>





// WEBPACK FOOTER //
// src/containers/About/About.vue